"use strict";
/*!
 * Buttplug JS Source Code File - Visit https://buttplug.io for more info about
 * the project. Licensed under the BSD 3-Clause license. See LICENSE file in the
 * project root for full license information.
 *
 * @copyright Copyright (c) Nonpolynomial Labs LLC. All rights reserved.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebBluetoothDeviceManager = void 0;
const Logging_1 = require("../../../core/Logging");
const Exceptions_1 = require("../../../core/Exceptions");
const events_1 = require("events");
const DeviceConfigurationManager_1 = require("../../../devices/configuration/DeviceConfigurationManager");
const BluetoothLEProtocolConfiguration_1 = require("../../../devices/configuration/BluetoothLEProtocolConfiguration");
const WebBluetoothDevice_1 = require("./WebBluetoothDevice");
const ButtplugDevice_1 = require("../../../devices/ButtplugDevice");
class WebBluetoothDeviceManager extends events_1.EventEmitter {
    constructor(aLogger) {
        super();
        this.OpenDevice = (aDevice) => __awaiter(this, void 0, void 0, function* () {
            if (aDevice === undefined) {
                // TODO Throw here?
                return;
            }
            // TODO Use DeviceConfigurationManager to get a device factory here.
            const mgr = DeviceConfigurationManager_1.DeviceConfigurationManager.Manager;
            const searchConfig = new BluetoothLEProtocolConfiguration_1.BluetoothLEProtocolConfiguration([aDevice.name]);
            const matchSpec = mgr.Find(searchConfig);
            if (matchSpec === undefined) {
                // TODO For WebBluetooth, we should never get here and should probably throw.
                return;
            }
            const [matchConfig, matchProtocolType] = matchSpec;
            const webBtDevice = new WebBluetoothDevice_1.WebBluetoothDevice(matchConfig, aDevice);
            yield webBtDevice.Connect();
            const protocol = new matchProtocolType(webBtDevice);
            const device = new ButtplugDevice_1.ButtplugDevice(protocol, webBtDevice);
            yield device.Initialize();
            this.emit("deviceadded", device);
        });
        this.SetLogger(aLogger !== undefined ? aLogger : Logging_1.ButtplugLogger.Logger);
    }
    SetLogger(aLogger) {
        this._logger = aLogger;
    }
    StartScanning() {
        return __awaiter(this, void 0, void 0, function* () {
            // Form scanning filters
            // TODO Get bluetooth device info from device configuration manager here.
            // Check the user agent for android, so we can substitute in
            // acceptAllDevices until the Chrome namePrefix bug is fixed.
            var userAgent = navigator.userAgent.toLowerCase();
            var isAndroid = userAgent.indexOf("android") > -1;
            let filters;
            // If we're on any platform other than android, use name filters
            if (!isAndroid) {
                filters = {
                    filters: new Array(),
                    optionalServices: new Array(),
                };
            }
            else {
                // Otherwise, just accept everything.
                filters = {
                    acceptAllDevices: true,
                    optionalServices: new Array(),
                };
            }
            // If the DeviceConfigurationManager hasn't been built yet, we've got a
            // problem. So just expect we'll get one back.
            const confMgr = DeviceConfigurationManager_1.DeviceConfigurationManager.Manager;
            const bluetoothConfigs = confMgr.GetAllConfigsOfType(BluetoothLEProtocolConfiguration_1.BluetoothLEProtocolConfiguration);
            for (const config of bluetoothConfigs) {
                if (!isAndroid) {
                    for (const deviceName of config.Names) {
                        try {
                            // We have to cast filters to any here because the logic + split value type doesn't work well.
                            if (deviceName.endsWith("*")) {
                                filters.filters.push({ namePrefix: deviceName.substr(0, deviceName.length - 1) });
                            }
                            filters.filters.push({ name: deviceName });
                        }
                        catch (e) {
                            console.log(e);
                            console.log(config);
                        }
                    }
                }
                filters.optionalServices = [...filters.optionalServices, ...config.Services.keys()];
            }
            this._logger.Trace("Bluetooth filter set: " + JSON.stringify(filters));
            // At some point, we should use navigator.bluetooth.getAvailability() to
            // check whether we have a radio to use. However, no browser currently
            // implements this. Instead, see if requestDevice throws;
            let device;
            try {
                device = yield (navigator.bluetooth).requestDevice(filters);
            }
            catch (e) {
                this.emit("scanningfinished");
                // This is the only way we have to check whether the user cancelled out of
                // the dialog versus bluetooth radio not being available, as both errors
                // are thrown as DOMExcpetion. Kill me.
                if (e.message.indexOf("User cancelled") !== -1) {
                    return;
                }
                throw Exceptions_1.ButtplugException.LogAndError(Exceptions_1.ButtplugDeviceException, this._logger, "Bluetooth scanning interrupted. " +
                    "Either user cancelled out of dialog, " +
                    "or bluetooth radio is not available. Exception: " + e);
            }
            try {
                yield this.OpenDevice(device);
            }
            catch (e) {
                this.emit("scanningfinished");
                throw Exceptions_1.ButtplugException.LogAndError(Exceptions_1.ButtplugDeviceException, this._logger, `Cannot open device ${device.name}: ${e}`);
            }
            this.emit("scanningfinished");
        });
    }
    StopScanning() {
        // noop. We can only scan via the browser dialog, and we can't cancel that from outside.
    }
    get IsScanning() {
        // noop.
        return false;
    }
}
exports.WebBluetoothDeviceManager = WebBluetoothDeviceManager;
//# sourceMappingURL=WebBluetoothDeviceManager.js.map